<template>
  <div class="row">
    <div class="col-12">
      <b-card v-if='loadingData'>
        <LoadingSpinner size = '1x'/>
      </b-card>
      <div v-else>
        <b-table
          :id="`history-${budgetYear.year}-table`"
          bordered
          :ref="`history-${budgetYear.year}-table`"
          head-variant="light"
          :fields="fields"
          :items="annualBudgetHistoryItems"
          class="list-item-table"
          show-empty>
          <template v-slot:cell(fundingSource)="row">
            {{ getFundingSource(row.item) }}
          </template>
        </b-table>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import LoadingSpinner from '@/components/common/LoadingSpinner.vue';
import ProjectTotalsCalculator from '@/mixins/projectTotalsCalculator';

export default {
  name: 'AnnualBudgetIncreases',
  mixins: [
    ProjectTotalsCalculator,
  ],
  components: {
    LoadingSpinner,
  },
  computed: {
    ...mapState('Project', {
      fundingSourcesLoading: (state) => state.fundingSourcesLoading,
      fundingSources: (state) => state.fundingSources,
      loadingAnnualBudgetHistoryItems: (state) => state.loadingAnnualBudgetHistoryItems,
      historyItems: (state) => state.annualBudgetHistoryItems,
    }),
    // loadingData() {
    //   if (!this.budgetYear) {
    //     return [];
    //   }
    //   return this.loadingAnnualBudgetHistoryItems[this.budgetYear.id];
    // },
    loadingData() {
      let loading = true;

      if (!this.budgetYear) {
        console.debug(`Exit loadingData(): ${loading} (!this.budgetYear)`);
      }

      // NOTE: this.loadingAnnualBudgetHistoryItems is an object, not an array
      loading = this.loadingAnnualBudgetHistoryItems[this.budgetYear.id];

      return loading;
    },
    annualBudgetHistoryItems() {
      if (!this.budgetYear) {
        return [];
      }
      return this.historyItems[this.budgetYear.id];
    },
  },
  props: {
    budgetYear: Object,
  },
  data() {
    return {
      fields: [
        {
          key: 'eventType',
          label: 'Event Type',
          class: 'text-column',
        },
        {
          key: 'changeToAnnualBudget',
          label: 'Change to Annual Budget',
          class: 'price-column',
          formatter: (value) => {
            if (!value) {
              return this.$options.filters.toCurrency(0.0);
            }
            return this.$options.filters.toCurrency(value);
          },
        },
        {
          key: 'annualBudgetAmount',
          label: 'Annual Budget Amount',
          class: 'price-column',
          formatter: (value) => {
            if (!value) {
              return this.$options.filters.toCurrency(0.0);
            }
            return this.$options.filters.toCurrency(value);
          },
        },
        {
          key: 'changeToProjectBudget',
          label: 'Change to Project Budget',
          class: 'price-column',
          formatter: (value) => {
            if (!value) {
              return this.$options.filters.toCurrency(0.0);
            }
            return this.$options.filters.toCurrency(value);
          },
        },
        {
          key: 'eventDate',
          label: 'Event Date',
          formatter: (value) => {
            let newVal = value;
            if (typeof value === 'string') {
              newVal = new Date(value);
            }
            return newVal ? newVal.toLocaleDateString('en-US', { type: 'short' }) : null;
          },
          class: 'date-column',
        },
        {
          key: 'createdBy',
          label: 'Changed By',
          class: 'text-column',
        },
        {
          key: 'fundingSource',
          label: 'Funding Source',
          class: 'text-column',
        },
      ],
    };
  },
  mounted() {
    this.$store.dispatch('Project/fetchAnnualBudgetHistoryItems', this.budgetYear.id);
  },
};
</script>
